import React from 'react';
import { string } from 'prop-types';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';

// utils
import { useUserRolePermissions } from 'hooks';

const CardHeaderSkeleton = ({ viewBy }) => {
  return (
    <Box mb={0.5}>
      <Box height={28} width="100">
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
      {viewBy === 'location' && (
        <Box height={20} mt={0.5} width="50%">
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
      )}
    </Box>
  );
};

CardHeaderSkeleton.propTypes = {
  viewBy: string,
};

CardHeaderSkeleton.defaultProps = {
  viewBy: undefined,
};

const CardBodySkeleton = () => {
  return (
    <>
      <Box data-testid="skeleton" display="flex" justifyContent="center" mt={1}>
        <Divider width="130px" />
      </Box>
      <Box
        alignSelf="center"
        display="flex"
        flexDirection="column"
        height={64}
        mb={2}
        pt="10px"
        width="30%"
      >
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
      <Box height={61} mb={2}>
        <Skeleton height="100%" variant="rectangular" width="100%" />
      </Box>
    </>
  );
};

const CardFooterSkeleton = () => {
  const { isProductLoadingManage } = useUserRolePermissions();
  return (
    <>
      {isProductLoadingManage && (
        <Box display="flex" justifyContent="center">
          <Box height={36}>
            <Skeleton
              height="100%"
              sx={{ borderRadius: '25px' }}
              variant="rectangular"
              width="100px"
            />
          </Box>
        </Box>
      )}
    </>
  );
};

const CarrierAuthCardSkeleton = ({ viewBy }) => {
  return (
    <Card
      sx={{
        height: 'auto',
        minHeight: 234,
      }}
      variant="loading"
    >
      <CardContent variant="loading">
        <CardHeaderSkeleton viewBy={viewBy} />
        <CardBodySkeleton />
        <CardFooterSkeleton />
      </CardContent>
    </Card>
  );
};

CarrierAuthCardSkeleton.propTypes = {
  viewBy: string,
};

CarrierAuthCardSkeleton.defaultProps = {
  viewBy: undefined,
};

export default CarrierAuthCardSkeleton;
